module.exports = __webpack_public_path__ + "static/media/pexels-brayden-law-3329736.7d7bcf83.jpg";